import { render, staticRenderFns } from "./SentimentCyclicalityVIP.vue?vue&type=template&id=478fe1a4&scoped=true"
import script from "./SentimentCyclicalityVIP.vue?vue&type=script&lang=js"
export * from "./SentimentCyclicalityVIP.vue?vue&type=script&lang=js"
import style0 from "./SentimentCyclicalityVIP.vue?vue&type=style&index=0&id=478fe1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fe1a4",
  null
  
)

export default component.exports